import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { Simplify } from '../../../../prismicio-types';
import styles from './TurnbullImageContent.module.scss';
import { BlueCheckmarkIcon } from '@/assets/icons/PartnerPagesIcons';

interface Props {
  data: Simplify<Content.PartnerHeroSliceTurnbullPrimary>;
}

const TurnbullImageContent = ({ data }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.benefitsWrapper}>
        <p className={styles.benefitsTitle}>{data.infotitle}</p>
        <ul className={styles.benefitsList}>
          {data.labels.map((label) => (
            <li key={label.text} className={styles.benefitsItem}>
              <PrismicNextImage
                field={label.icon}
                className={styles.benefitsIcon}
              />
              {label.text}
            </li>
          ))}
        </ul>
        <div className={styles.firstEllipse} />
        <div className={styles.firstEllipse} />
        <div className={styles.secondEllipse} />
      </div>
      <div className={styles.personImgWrapper}>
        <PrismicNextImage field={data.personimg} className={styles.personImg} />
        <PrismicNextImage field={data.partnerlogo} className={styles.logo} />
        <div className={styles.checkmarkWrapper}>
          <BlueCheckmarkIcon className={styles.blueCheckmark} />
        </div>
      </div>
    </div>
  );
};

export default TurnbullImageContent;
